export enum HTTP_RES_ERROR_CODE {
    UNAUTHORIZED = 401,
    BADREQUEST = 400,
    FORBIDDEN = 403,
    NOTFOUND = 404,
    INTERNALSERVERERROR = 500   
}